import request from "../utils/request"

export function fetchAdminSquarePosts(params = {}) {
  return request({
    url: "/admin/square-posts",
    method: "get",
    params
  })
}

export function fetchAdminSquareStats() {
  return request({
    url: "/admin/square-posts/stats",
    method: "get"
  })
}

export function updateAdminSquarePostStatus(id, auditStatus) {
  return request({
    url: `/admin/square-posts/${id}/status`,
    method: "post",
    params: { auditStatus }
  })
}

export function deleteAdminSquarePost(id) {
  return request({
    url: `/admin/square-posts/${id}/delete`,
    method: "post"
  })
}

export function restoreAdminSquarePost(id) {
  return request({
    url: `/admin/square-posts/${id}/restore`,
    method: "post"
  })
}
